export default {
  meta: {
    title: '铺位详情'
  }
};
